import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";


export default function SquareCardForm({
  applicationId,
  locationId,
  onNonce,
  onError,
  label = "Pay with Card",
}) {
  const [card, setCard] = useState(null);
  const [isCardReady, setIsCardReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function initCardForm() {
      try {
        // Ensure the Square script is loaded and that window.Square is available
        if (!window.Square) {
          throw new Error(
            "Square.js not found. Make sure <script src='https://web.squarecdn.com/v1/square.js'></script> is in index.html"
          );
        }

        // Create the 'payments' object from window.Square
        const paymentsObj = window.Square.payments(applicationId, locationId);

        // Create a "card" instance
        const cardInstance = await paymentsObj.card();
        await cardInstance.attach("#card-container"); // div ID to attach form into

        if (isMounted) {
          setCard(cardInstance);
          setIsCardReady(true);
        }
      } catch (err) {
        console.error("Error initializing Square card form:", err);
        if (onError) onError(err);
      }
    }

    initCardForm();

    return () => {
      isMounted = false; // cleanup
    };
  }, [applicationId, locationId, onError]);

  // Called when user clicks the "Pay with Card" button
  const handleTokenize = async () => {
    if (!card) {
      console.warn("Square card instance is not ready yet.");
      return;
    }

    try {
      const result = await card.tokenize();
      if (result.status === "OK") {
        // We have a valid card nonce
        if (onNonce) onNonce(result.token);
      } else {
        // Could have errors in result.errors
        console.error("Square card tokenization failed:", result.errors);
        if (onError) onError(result.errors);
      }
    } catch (tokenizeError) {
      console.error("Exception while tokenizing card:", tokenizeError);
      if (onError) onError(tokenizeError);
    }
  };

  return (
    <div>
      {/* Container for Square to inject the card input fields */}
      <div
        id="card-container"
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "16px",
          minHeight: "150px",
          marginBottom: "12px",
        }}
      />

      <button
        onClick={handleTokenize}
        disabled={!isCardReady}
        style={{
          padding: "8px 16px",
          cursor: isCardReady ? "pointer" : "default",
          opacity: isCardReady ? 1 : 0.6,
        }}
      >
        {label}
      </button>
    </div>
  );
}

SquareCardForm.propTypes = {
  applicationId: PropTypes.string.isRequired,
  locationId: PropTypes.string.isRequired,
  onNonce: PropTypes.func,
  onError: PropTypes.func,
  label: PropTypes.string,
};
